<script setup>
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    year: String,
    invoiceProforma: Object,
    agent: Object,
    user: Object,
});
dayjs.extend(advancedFormat);

//currency formatter
function formatPrice(value) {
    let val = (value / 1).toFixed(2).replace('.', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

//convert number to words
function convertNumberToWords(amount) {
    let words = new Array();
    words[0] = '';
    words[1] = 'One';
    words[2] = 'Two';
    words[3] = 'Three';
    words[4] = 'Four';
    words[5] = 'Five';
    words[6] = 'Six';
    words[7] = 'Seven';
    words[8] = 'Eight';
    words[9] = 'Nine';
    words[10] = 'Ten';
    words[11] = 'Eleven';
    words[12] = 'Twelve';
    words[13] = 'Thirteen';
    words[14] = 'Fourteen';
    words[15] = 'Fifteen';
    words[16] = 'Sixteen';
    words[17] = 'Seventeen';
    words[18] = 'Eighteen';
    words[19] = 'Nineteen';
    words[20] = 'Twenty';
    words[30] = 'Thirty';
    words[40] = 'Forty';
    words[50] = 'Fifty';
    words[60] = 'Sixty';
    words[70] = 'Seventy';
    words[80] = 'Eighty';
    words[90] = 'Ninety';
    amount = amount.toString();
    let atemp = amount.split(".");
    let number = atemp[0].split(",").join("");
    let n_length = number.length;
    let words_string = "";
    if (n_length <= 9) {
        let n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let received_n_array = new Array();
        for (let i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);
        }
        for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
            n_array[i] = received_n_array[j];
        }
        for (let i = 0, j = 1; i < 9; i++, j++) {
            if (i == 0 || i == 2 || i == 4 || i ==
                7) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + parseInt(n_array[j]);
                    n_array[i] = 0;
                }
            }
        }
        let value = "";
        for (let i = 0; i < 9; i++) {
            if (i == 0 || i == 2 || i == 4 || i ==
                7) {
                value = n_array[i] * 10;
            } else {
                value = n_array[i];
            }
            if (value != 0) {
                words_string += words[value] + " ";
            }
            if ((i == 1 && value != 0) || (i == 0 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Crores ";
            }
            if ((i == 3 && value != 0) || (i == 2 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Lakhs ";
            }
            if ((i == 5 && value != 0) || (i == 4 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Thousand ";
            }
            if (i == 6 && value != 0 && (n_array[i +
                1] != 0 && n_array[i + 2] != 0)) {
                words_string += "Hundred and ";
            } else if (i == 6 && value != 0) {
                words_string += "Hundred ";
            }
        }
        words_string = words_string.split("  ").join(" ");
    }
    return words_string;
}
</script>
<template>

    <div class="row invoice-preview">
        <!-- Invoice -->
        <div class="mb-md-0 mb-4" style="width: 820px;">
            <div class="card invoice-preview-card">
                <div class="card-body pb-0 pt-0">
                    <div
                        class="d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column p-sm-3">
                        <div class="d-flex svg-illustration">
                            <span class="app-brand-logo">
                                <img style="width:200px;" v-if="props.agent.company"
                                    :src="'/storage/company_logos/' + props.agent.company?.logo" alt="logo">
                                <img style="width:200px;" v-else :src="'/storage/company_logos/' + props.agent?.logo"
                                    alt="logo">
                            </span>
                        </div>
                        <div class="pt-3">
                            <h4>Payment Receipt</h4>
                            <div>
                                <span class="fw-semibold">
                                    {{ dayjs().format('Do MMMM YYYY') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="my-0" />
                <div class="card-body pt-0 pb-0">
                    <div class="row p-sm-2 p-0">
                        <div class="col-12"
                            style="background:#efefef;padding-left:15px;padding-bottom:10px;padding-top:10px;">
                            <table>
                                <tr>
                                    <td style="font-size: 13px;letter-spacing: .5px;font-weight: bold;">
                                        Property
                                        Name:</td>
                                    <td>{{ props.invoiceProforma.bookings.hotel?.name }}</td>
                                </tr>
                                <tr>
                                    <td style="font-size: 13px;letter-spacing: .5px;font-weight: bold;">
                                        Booking
                                        Number:</td>
                                    <td><b>{{ props.invoiceProforma.bookings?.booking_no }}</b></td>
                                </tr>
                            </table>
                        </div>

                        <div class="col-xl-12 col-md-12 col-sm-5 col-12"
                            style="background-color: #e1f5fe; border-radius:4px; padding-top:10px; padding-left:15px; padding-bottom:10px; margin-top: 4px; margin-bottom: 4px;">
                            <table>
                                <tbody>
                                    <tr>
                                        <td class="pe-3"><strong>Agent:</strong></td>
                                        <td>{{ props.invoiceProforma.bookings?.agent?.agency_name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Paid Date:</strong></td>
                                        <td>
                                            {{ dayjs(props.invoiceProforma.paid_date).format('ddd, Do MMM YYYY') }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Payment Method:</strong></td>
                                        <td>{{ props.invoiceProforma.payment_mode }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Receipt Number:</strong></td>
                                        <td>{{ props.invoiceProforma.paid_receipt }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Amount Recieved:</strong></td>
                                        <td>{{ formatPrice(props.invoiceProforma.paid_amount) }} ({{
                                                convertNumberToWords(props.invoiceProforma?.paid_amount ?? 0)
                                        }} Only)</td>
                                    </tr>
                                    <tr>
                                        <td v-if="props.invoiceProforma.payment_note" class="pe-3"><strong>Extra
                                                Note:</strong></td>
                                        <td>{{ props.invoiceProforma.payment_note }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div align="center">
                    <table>
                        <tbody>
                            <tr style="font-size: 12px;">
                                <td colspan="4" align="center" style="padding: 9px;">
                                    <span v-if="$page.props.user.user_type == 'Company'"
                                        v-html="props.agent?.address2"></span>
                                    <span v-else v-html="props.agent.company?.address2"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template >